/**
 * WordPress dependencies
 */

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { default as InspectorInterface } from '../../interface/Inspector/index.js';
// import './inspector/tabs';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

const Inspector = ( props ) => {
	return <InspectorInterface hookPrefix={ hookPrefix } { ...props } />;
};

export default Inspector;
